import i18n, { Ti18nKeys } from "../../../../../constants/i18n";
import Et3CustomizedButton from "../../../../../core/et3-button/Et3CustomizedButton";
import {
  BUTTON_DISABLED_BACKGROUND,
  BUTTON_SHADOW,
  BUTTON_SHADOW_DISABLED
} from "../../../../../core/et3-button/button-constants";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import {
  SUMMARY_NAV_BUTTON_FONT_SIZE,
  SUMMARY_NAV_BUTTON_HEIGHT,
  SUMMARY_NAV_BUTTON_PADDING,
  SUMMARY_NAV_BUTTON_RADIUS_CSS
} from "./summary-header-constants";

const SummaryNavButton = withLiteObserverAndTheme<{
  labelKey: Ti18nKeys;
  isEnabled: boolean;
  onPress: () => void;
}>((props) => {
  const { labelKey, isEnabled, onPress, theme } = props;
  const { colors, unitX } = theme;

  return (
    <Et3CustomizedButton
      isEnabled={isEnabled}
      withShadow={false}
      width={0}
      height={SUMMARY_NAV_BUTTON_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={isEnabled ? colors.all.green : BUTTON_DISABLED_BACKGROUND}
      style={{
        boxSizing: "border-box",
        width: "auto",
        minWidth: 0,
        flexShrink: 0,
        whiteSpace: "nowrap",
        borderRadius: SUMMARY_NAV_BUTTON_RADIUS_CSS,
        boxShadow: isEnabled ? BUTTON_SHADOW : BUTTON_SHADOW_DISABLED,
        cursor: isEnabled ? "pointer" : "default",
        paddingLeft: SUMMARY_NAV_BUTTON_PADDING * unitX,
        paddingRight: SUMMARY_NAV_BUTTON_PADDING * unitX
      }}
      onClick={() => onPress()}
    >
      <Et3Text
        text={i18n.get(labelKey)}
        fontFamily="BOLD"
        fontSize={SUMMARY_NAV_BUTTON_FONT_SIZE}
        color={isEnabled ? colors.all.white : colors.all.dimGray}
        isSpan={true}
        style={{ margin: 0 }}
      />
    </Et3CustomizedButton>
  );
});
export default SummaryNavButton;
